import { render, staticRenderFns } from "./InvoiceStatus.vue?vue&type=template&id=0653f14a&"
import script from "./InvoiceStatus.vue?vue&type=script&lang=js&"
export * from "./InvoiceStatus.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports